"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faCheck = void 0;
var faCheck = {
  prefix: 'fal',
  iconName: 'faCheck',
  icon: [512, 512, [], '', 'M475.3 123.3l-272 272C200.2 398.4 196.1 400 192 400s-8.188-1.562-11.31-4.688l-144-144c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0L192 361.4l260.7-260.7c6.25-6.25 16.38-6.25 22.62 0S481.6 117.1 475.3 123.3z']
};
exports.faCheck = faCheck;